import { WSTable, WSTableItem } from "@wingspanhq/fe-component-library";
import { PayrollRun } from "@wingspanhq/wingspan-api-sdk";
import { useMemo } from "react";

import { getColumnsEmployee } from "./columns";

type Props = {
  items: PayrollRun[];
  loading?: boolean;
  /** Header export action; omitted when the table has nothing to export. */
  onDownload?: () => void;
  downloading?: boolean;
  onRowOpen?: (id: string) => void;
};

/**
 * The employee payroll history table: the new design's columns, a header export
 * action and a per-row menu. The Payables tab has its own, deliberately plainer
 * table (`TablePayrollsContractor`).
 */
export const TablePayrollsEmployee: React.FC<Props> = props => {
  const tableData = useMemo<WSTableItem<PayrollRun>[]>(
    () => props.items.map(item => ({ id: item.id ?? "", data: item })),
    [props.items]
  );
  const columns = useMemo(() => getColumnsEmployee(), []);

  return (
    <WSTable<PayrollRun>
      columns={columns}
      headerAction={
        props.onDownload
          ? {
              icon: "download",
              loading: props.downloading,
              onClick: props.onDownload
            }
          : undefined
      }
      loading={props.loading}
      rowMenuActions={item => [
        {
          icon: "file",
          label: "View details",
          onClick: () => props.onRowOpen?.(item.id)
        }
      ]}
      tableData={tableData}
      onRowClick={item => props.onRowOpen?.(item.id)}
    />
  );
};
